import {Autocomplete, CardContent, Checkbox, FormControlLabel, FormHelperText, TextField} from "@mui/material";
import {EditForm} from "@variocube/app-ui";
import React, {useEffect, useState} from "react";
import {useAsync} from "react-async-hook";
import {SearchSettings, useLocationApi} from "../../api";
import {useLocalization} from "@smalox/shared";
import {useNumericParam} from "../../utils/useParam";

export function LocationSearchSettings() {
	const {t} = useLocalization();
	const locationId = useNumericParam("locationId");
	const {getLocationSearchSettings, updateLocationSearchSettings} = useLocationApi();

	const {loading, result: searchSettings} = useAsync(getLocationSearchSettings, [locationId]);

	const [findable, setFindable] = useState<boolean>(false);
	const [searchName, setSearchName] = useState<string>("");
	const [searchTerms, setSearchTerms] = useState<string[]>([]);

	// Sync state from loaded searchSettings
	useEffect(() => {
		if (searchSettings) {
			setFindable(searchSettings.findable ?? false);
			setSearchName(searchSettings.searchName ?? "");
			setSearchTerms(searchSettings.searchTerms ?? []);
		}
	}, [searchSettings]);

	async function handleSave() {
		const settings: SearchSettings = {
			findable,
			searchName: searchName || undefined,
			searchTerms,
		};
		await updateLocationSearchSettings(locationId, settings);
	}

	return (
		<EditForm loading={loading} labels={t} onSave={handleSave}>
			<CardContent>
				<FormControlLabel
					control={
						<Checkbox
							checked={findable}
							onChange={e => setFindable(e.target.checked)}
						/>
					}
					label={t("searchSettings.findable")}
				/>
				<FormHelperText>{t("searchSettings.findableHelperText")}</FormHelperText>
			</CardContent>
			<CardContent>
				<TextField
					label={t("searchSettings.searchName")}
					value={searchName}
					onChange={e => setSearchName(e.target.value)}
					fullWidth
					inputProps={{maxLength: 255}}
					helperText={t("searchSettings.searchNameHelperText")}
				/>
			</CardContent>
			<CardContent>
				<Autocomplete
					multiple
					freeSolo
					options={[]}
					value={searchTerms}
					onChange={(_, newValue) => setSearchTerms(newValue)}
					renderInput={params => (
						<TextField
							{...params}
							label={t("searchSettings.searchTerms")}
							helperText={t("searchSettings.searchTermsHelperText")}
						/>
					)}
				/>
			</CardContent>
		</EditForm>
	);
}
